import { setAlert } from '../../alert';
import api from '../../../util/api';
import {
    API_POST_CONVERSIONS_DATA,
    API_GET_CONVERSIONS_DATA,
    API_GET_GROUPS,
    API_UPLOAD_CF_CSV_DOCUMENT,
    getFormDataConfig,
    API_GET_USER_COMPANY_DATA
} from '../constants/00-base-constants';
import {
    POST_CONVERSIONS_SUCCESS,
    POST_CONVERSIONS_FAIL,
    GET_CONVERSIONS_SUCCESS,
    GET_CONVERSIONS_FAIL,
    GET_GROUPS_SUCCESS,
    GET_GROUPS_FAIL,
    UPLOAD_CSV_DOCUMENT_FAIL,
    UPLOAD_CSV_DOCUMENT_SUCCESS,
    GET_USER_COMPANY_DATA_SUCCESS,
    GET_USER_COMPANY_DATA_FAIL
} from '../types/00-base-types';

const config = {
    headers: {
        'Content-Type': 'application/json',
    }
};

export const postConversions = (formData, year, company) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_CONVERSIONS_DATA + `/${year}/${company}`,
            formData,
            config
        );
        dispatch({
            type: POST_CONVERSIONS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_CONVERSIONS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getConversions = (year, company) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_CONVERSIONS_DATA + `/${year}/${company}`,
            config
        );
        dispatch({
            type: GET_CONVERSIONS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_CONVERSIONS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getGroups = (company) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_GROUPS + `/${company}`,
            config
        );
        dispatch({
            type: GET_GROUPS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_GROUPS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getUserCompanyData = (companyId, groupId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_USER_COMPANY_DATA + `/${companyId}/${groupId}`,
            config
        );
        dispatch({
            type: GET_USER_COMPANY_DATA_SUCCESS,
            payload: data,
        });
        // dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        // dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_USER_COMPANY_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const uploadCsvDocument = (formData, companyId, year, groupId, facilityId, selectedCategory) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_UPLOAD_CF_CSV_DOCUMENT + `/${companyId}/${year}/${groupId}/${facilityId}/${selectedCategory}`,
            formData,
            getFormDataConfig()
        )
        dispatch({
            type: UPLOAD_CSV_DOCUMENT_SUCCESS,
            payload: data,
        });
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: UPLOAD_CSV_DOCUMENT_FAIL,
            payload: err.response.data.detail,
        });
    }
};